import { EXCLUDE_FROM_TIMESLIDER } from '../config/constants'

const combineTimestamps = timestamps => {
  const filteredTimestamps = Object.keys(timestamps)
    .filter(key => !EXCLUDE_FROM_TIMESLIDER.includes(key))
    .map(key => timestamps[key])
  const combinedTimestamps = [].concat.apply([], filteredTimestamps)

  return combinedTimestamps.sort()
}

export default combineTimestamps



// WEBPACK FOOTER //
// ./src/utility/combineTimestamps.js